export const name = 'siteConfigurationService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-configuration'
